import HTTP_METHOD from "enums/HTTP_METHOD";
import endpoints from "hooks/api/endpoints";
import useApiWrite from "hooks/api/useApiWrite";

export default function useCreateResetPasswordToken() {
  const { write, ...rest } = useApiWrite();

  async function createResetPasswordToken(email: string): Promise<void> {
    await write<void>({
      url: endpoints.forgotPassword(email),
      method: HTTP_METHOD.PUT,
      suppressErrorNotification: true,
    });
  }

  return { createResetPasswordToken, ...rest };
}
